module.exports = __webpack_public_path__ + "static/media/metrosector.8f06fa68.jpg";